/* Lisa Kookt — Mix & Match smakenlade (LK, 14-08-2026)
   Markup komt uit snippets/lk-smakenlade.liquid + lk-smakenlade-row.liquid.
   Toevoegen gaat via een eigen POST naar /cart/add.js met een items-array,
   bewust losgekoppeld van de bestaande productformulieren.

   15-08-2026 — geschikt gemaakt voor producten met MEERDERE VARIANTEN
   (Lisa's Witbrood bakmix: 400 gram / 2000 gr). Zie de vier blokken gemarkeerd
   met MULTIVARIANT hieronder. Whey en wraps zijn allemaal single-variant, dus
   dit pad is nooit eerder geraakt.

   15-09-2026 — UITVERKOCHT (JJ). De eigen regel ("jouw keuze") kreeg altijd een
   stepper met 1, ook als het product uitverkocht was (Cooking Spray Garlic).
   lk-smakenlade-row.liquid zet nu data-soldout="1" op die regel; hier wordt dan
   het label "Uitverkocht" getekend, het aantal op 0 gehouden en de regel niet
   vanaf de pagina gesynchroniseerd. Bij een variantwissel (lk:variant-change)
   wordt de beschikbaarheid opnieuw bepaald: uit e.detail.available als het thema
   dat meestuurt, anders uit de disabled-staat van de winkelwagenknop. Zie de
   blokken gemarkeerd met UITVERKOCHT. */
(function () {
  'use strict';

  function euro(cents, fmt) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && fmt) {
      try { return Shopify.formatMoney(cents, fmt); } catch (e) {}
    }
    var s = (cents / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + s[0] + ',' + s[1];
  }

  function parseTiers(raw) {
    var out = [];
    if (!raw) return out;
    raw.split(',').forEach(function (part) {
      var kv = part.split('=');
      var q = Number((kv[0] || '').trim());
      var p = Number((kv[1] || '').trim());
      if (q >= 2 && p > 0) out.push({ q: q, p: p });
    });
    out.sort(function (a, b) { return b.q - a.q; });
    return out;
  }

  function init(root) {
    if (!root || root.dataset.lkSmlReady === '1') return;
    root.dataset.lkSmlReady = '1';

    var TIERS = parseTiers(root.getAttribute('data-tiers'));
    var FMT = root.getAttribute('data-money-format') || '';
    var rows = [].slice.call(root.querySelectorAll('[data-lk-row]'));
    var totalEl = root.querySelector('[data-lk-total]');
    var subEl = root.querySelector('[data-lk-sub]');
    var barEl = root.querySelector('[data-lk-bar]');
    var addBtn = root.querySelector('[data-lk-add]');
    var qty = {};
    var drawFns = [];
    var selfIndex = -1;

    // MULTIVARIANT 1 — de trigger staat naast de lade in dezelfde sectie. Document-
    // breed zoeken pakte na een variantwissel de verouderde knop uit de vorige
    // sectie-HTML, waardoor de nieuwe knop dood bleef.
    var triggerScope = root.parentNode || document;
    var trigger = triggerScope.querySelector('[data-lk-sml-open]') ||
                  document.querySelector('[data-lk-sml-open]');

    // MULTIVARIANT 2 — hertekent een thema de sectie wél bij een variantwissel,
    // dan komt er een nieuwe lade uit de HTML terwijl de vorige nog onder <body>
    // hangt (zie hieronder) met hetzelfde id. Die ruimen we eerst op.
    if (root.id) {
      [].slice.call(document.querySelectorAll('[data-lk-sml]')).forEach(function (el) {
        if (el !== root && el.id === root.id && el.parentNode) el.parentNode.removeChild(el);
      });
    }

    // De lade is fixed gepositioneerd; naar <body> verplaatsen zodat een ancestor
    // met transform/filter geen eigen containing block kan maken.
    if (root.parentNode !== document.body) document.body.appendChild(root);

    // Het aantal-veld van het gewone productformulier. De volumetegels zetten dit
    // veld; we lezen het bij het openen zodat de lade laat zien wat er al gekozen is.
    function pageQtyInput() {
      var scope = (trigger && trigger.closest('.product__info-container')) || document;
      return scope.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
             scope.querySelector('quantity-input input[name="quantity"]') ||
             document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    }

    // UITVERKOCHT 1 — de winkelwagenknop van het productformulier. Dawn zet die
    // op disabled zodra de gekozen variant uitverkocht is; dat is de fallback
    // om na een variantwissel de beschikbaarheid te bepalen.
    function pageSubmitBtn() {
      var scope = (trigger && trigger.closest('.product__info-container')) || document;
      return scope.querySelector('form[action*="/cart/add"] [type="submit"]') ||
             document.querySelector('form[action*="/cart/add"] [type="submit"]');
    }
    function isSoldOut(row) { return row.getAttribute('data-soldout') === '1'; }

    function tierFor(n) {
      for (var i = 0; i < TIERS.length; i++) { if (n >= TIERS[i].q) return TIERS[i].p; }
      return 0;
    }
    function nextTier(n) {
      var best = null;
      TIERS.forEach(function (t) { if (t.q > n && (!best || t.q < best.q)) best = t; });
      return best;
    }
    function stuks(n) { return n + (n === 1 ? ' stuk' : ' stuks'); }

    function recalc() {
      var n = 0, gross = 0;
      rows.forEach(function (row, i) {
        var q = qty[i] || 0;
        n += q;
        gross += q * (Number(row.getAttribute('data-price')) || 0);
      });
      var pct = tierFor(n);
      var net = Math.round(gross * (1 - pct / 100));

      if (!n) {
        totalEl.innerHTML = '<span class="lk-sml__leegtxt">Nog geen smaken gekozen</span>';
        subEl.textContent = TIERS.length
          ? 'Vanaf ' + TIERS.slice().reverse().map(function (t) { return t.q + ' stuks ' + t.p + '%'; }).join(' · ')
          : '';
        if (barEl) barEl.style.width = '0%';
        addBtn.disabled = true;
        addBtn.innerHTML = 'Toevoegen aan winkelmand';
        return;
      }

      addBtn.disabled = false;
      // Vaste knoptekst met het aantal erin: maakt duidelijk dat de plusjes alleen
      // selecteren en dat de winkelmand pas hier gevuld wordt.
      addBtn.innerHTML = 'Toevoegen aan winkelmand <span class="lk-sml__ctan">' + n + '</span>';

      var html = '<span class="lk-sml__cnt">' + stuks(n) + ' gekozen</span>';
      if (pct) {
        html += '<s>' + euro(gross, FMT) + '</s>';
        html += '<em>−' + pct + '%</em>';
        html += '<strong>' + euro(net, FMT) + '</strong>';
      } else {
        html += '<strong>' + euro(gross, FMT) + '</strong>';
      }
      totalEl.innerHTML = html;

      var nx = nextTier(n);
      subEl.textContent = TIERS.length
        ? (nx ? 'Nog ' + stuks(nx.q - n) + ' tot ' + nx.p + '% korting' : 'Hoogste volumekorting bereikt')
        : '';
      if (barEl && TIERS.length) barEl.style.width = Math.min(100, (n / TIERS[0].q) * 100) + '%';
    }

    rows.forEach(function (row, i) {
      if (row.getAttribute('data-self') === '1') {
        // UITVERKOCHT 2 — een uitverkochte eigen regel start op 0, niet op 1.
        qty[i] = isSoldOut(row) ? 0 : 1;
        selfIndex = i;
      }
      var act = row.querySelector('.lk-sml__act');

      function draw() {
        var q = qty[i] || 0;
        act.innerHTML = '';

        // UITVERKOCHT 3 — geen stepper en geen plusje, maar een label. Opmaak
        // inline, net als het lade_badge-pilletje in lk-smakenlade-row.liquid.
        if (isSoldOut(row)) {
          qty[i] = 0;
          var uit = document.createElement('span');
          uit.className = 'lk-sml__uit';
          uit.textContent = 'Uitverkocht';
          uit.setAttribute('style', 'display:inline-block;font-size:11px;font-weight:700;color:#8a5a3c;' +
            'background:rgba(217,122,77,.12);border:1.5px solid rgba(217,122,77,.35);' +
            'padding:6px 10px;border-radius:9px;white-space:nowrap;line-height:1;');
          act.appendChild(uit);
          row.classList.add('is-on');
          return;
        }

        if (!q) {
          var add = document.createElement('button');
          add.type = 'button';
          add.className = 'lk-sml__addb';
          add.textContent = '+';
          add.setAttribute('aria-label', 'Kies ' + (row.getAttribute('data-naam') || ''));
          add.addEventListener('click', function () { qty[i] = 1; draw(); recalc(); });
          act.appendChild(add);
          row.classList.remove('is-on');
        } else {
          var wrap = document.createElement('span');
          wrap.className = 'lk-sml__stp';
          var minus = document.createElement('button');
          minus.type = 'button'; minus.innerHTML = '&#8722;'; minus.setAttribute('aria-label', 'Minder');
          var val = document.createElement('span'); val.textContent = q;
          var plus = document.createElement('button');
          plus.type = 'button'; plus.innerHTML = '&#43;'; plus.setAttribute('aria-label', 'Meer');
          minus.addEventListener('click', function () { qty[i] = Math.max(0, q - 1); draw(); recalc(); });
          plus.addEventListener('click', function () { qty[i] = q + 1; draw(); recalc(); });
          wrap.appendChild(minus); wrap.appendChild(val); wrap.appendChild(plus);
          act.appendChild(wrap);
          row.classList.add('is-on');
        }
      }
      drawFns[i] = draw;
      draw();

      var starsBtn = row.querySelector('[data-lk-stars]');
      var slat = row.nextElementSibling;
      if (starsBtn && slat && slat.hasAttribute('data-lk-slat')) {
        starsBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var wasOpen = !slat.hidden;
          root.querySelectorAll('[data-lk-slat]').forEach(function (s) { s.hidden = true; });
          root.querySelectorAll('[data-lk-stars]').forEach(function (s) { s.setAttribute('aria-expanded', 'false'); });
          if (!wasOpen) {
            slat.hidden = false;
            starsBtn.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });

    /* MULTIVARIANT 3 — de eigen regel is server-side gerenderd met de variant die
       bij het laden geselecteerd was. Wisselt de klant daarna van variant, dan
       hertekent dit thema de sectie niet, dus zou hier de prijs (en het
       variant-id waarmee we toevoegen!) van de vorige variant blijven staan.
       quantity-buttons-stacked.liquid vuurt hiervoor 'lk:variant-change'. */
    var selfSuffix = '';
    if (selfIndex >= 0) {
      var prijsEl0 = rows[selfIndex].querySelector('.lk-sml__prijs');
      if (prijsEl0) {
        var deel = prijsEl0.textContent.split('·');
        if (deel.length > 1) selfSuffix = deel.slice(1).join('·').trim();
      }
    }

    window.addEventListener('lk:variant-change', function (e) {
      var d = e && e.detail;
      if (!d || selfIndex < 0) return;
      var row = rows[selfIndex];
      if (!row) return;
      row.setAttribute('data-id', d.variantId);
      row.setAttribute('data-price', d.price);
      var prijsEl = row.querySelector('.lk-sml__prijs');
      if (prijsEl) {
        var suffix = (d.title && d.title !== 'Default Title') ? d.title : selfSuffix;
        prijsEl.textContent = euro(d.price, FMT) + (suffix ? ' · ' + suffix : '');
      }

      // UITVERKOCHT 4 — beschikbaarheid van de nieuwe variant opnieuw bepalen.
      var beschikbaar = null;
      if (typeof d.available === 'boolean') {
        beschikbaar = d.available;
      } else {
        var btn = pageSubmitBtn();
        if (btn) beschikbaar = !btn.disabled;
      }
      if (beschikbaar === false) {
        row.setAttribute('data-soldout', '1');
        qty[selfIndex] = 0;
      } else if (beschikbaar === true && isSoldOut(row)) {
        row.removeAttribute('data-soldout');
        qty[selfIndex] = 1;
      }
      if (drawFns[selfIndex]) drawFns[selfIndex]();

      recalc();
    });

    // Neem bij het openen het aantal over dat op de pagina staat (volumetegels of
    // stepper), zodat "3 zakken" niet als 1 in de lade verschijnt.
    function syncFromPage() {
      if (selfIndex < 0) return;
      if (isSoldOut(rows[selfIndex])) return; // UITVERKOCHT 5
      var input = pageQtyInput();
      if (!input) return;
      var q = Number(input.value);
      if (!isFinite(q) || q < 1) q = 1;
      if (qty[selfIndex] === q) return;
      qty[selfIndex] = q;
      if (drawFns[selfIndex]) drawFns[selfIndex]();
    }

    function open() {
      syncFromPage();
      recalc();
      root.hidden = false;
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
        document.body.classList.add('lk-sml-lock');
      });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('lk-sml-lock');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 340);
    }

    if (trigger) trigger.addEventListener('click', open);
    root.querySelectorAll('[data-lk-sml-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    /* ---- Naar beneden vegen om te sluiten (alleen mobiel) --------------
       De sleepzone is de greep + de kop; het lijstje eronder blijft gewoon
       scrollbaar. Onder de 90 px veert de lade terug. */
    var sheetEl = root.querySelector('[data-lk-sheet]');
    var grabEl = root.querySelector('[data-lk-grab]');
    if (sheetEl && grabEl) {
      var startY = 0, moved = 0, dragging = false;

      var dragStart = function (e) {
        if (window.innerWidth >= 768) return;
        var t = e.touches ? e.touches[0] : e;
        startY = t.clientY;
        moved = 0;
        dragging = true;
        sheetEl.style.transition = 'none';
      };
      var dragMove = function (e) {
        if (!dragging) return;
        var t = e.touches ? e.touches[0] : e;
        moved = t.clientY - startY;
        if (moved < 0) moved = 0;
        sheetEl.style.transform = 'translateY(' + moved + 'px)';
        if (moved > 4 && e.cancelable) e.preventDefault();
      };
      var dragEnd = function () {
        if (!dragging) return;
        dragging = false;
        sheetEl.style.transition = '';
        sheetEl.style.transform = '';
        if (moved > 90) close();
        moved = 0;
      };

      grabEl.addEventListener('touchstart', dragStart, { passive: true });
      grabEl.addEventListener('touchmove', dragMove, { passive: false });
      grabEl.addEventListener('touchend', dragEnd);
      grabEl.addEventListener('touchcancel', dragEnd);
    }

    function cartUrl(path) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      return base.replace(/\/$/, '/') + path;
    }

    addBtn.addEventListener('click', function () {
      var items = [];
      rows.forEach(function (row, i) {
        var q = qty[i] || 0;
        if (q > 0) items.push({ id: Number(row.getAttribute('data-id')), quantity: q });
      });
      if (!items.length) return;

      addBtn.disabled = true;
      var payload = { items: items };
      var drawer = document.querySelector('cart-drawer');
      var canRender = drawer && typeof drawer.renderContents === 'function';
      if (canRender) {
        payload.sections = 'cart-drawer,cart-icon-bubble';
        payload.sections_url = window.location.pathname;
      }

      fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) throw new Error(res.description || 'cart');
          close();
          if (canRender && res.sections) {
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
              addBtn.disabled = false;
              return;
            } catch (e) {}
          }
          window.location.href = cartUrl('cart');
        })
        .catch(function () { window.location.href = cartUrl('cart'); });
    });

    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-lk-sml]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  // MULTIVARIANT 4 — vangnet voor thema's die de sectie-HTML wél vervangen bij
  // een variantwissel: dat gebeurt zonder shopify:section:load (dat is een
  // theme-editor event), dus zonder deze observer zou de nieuwe knop niets doen.
  // init() slaat bekende lades over via data-lk-sml-ready, dus dit is goedkoop.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-lk-sml]')) ||
              (n.querySelector && n.querySelector('[data-lk-sml]'))) {
            boot();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
